<div class="row">
  <div class="col-12" style="background-color: white;">
    @if (displayAttachments() === true) {
      <div  style="overflow-x: visible">
        @for (uploader of uploaders; track uploader) {
          <div >
            @if (isNewUpload(uploader.key) === true) {
              @if (isUploading == false && uploader.value.queue.length === 0) {
                <label class="btn btn-sm btn-outline-secondary" #newAttachmentLabel>
                  Add attachment<input class="btn btn-file" type="file" ng2FileSelect [uploader]="uploader.value" class="d-none" />
                </label>
              }
              @if (isUploading && uploader.value.queue.length > 0) {
                <span>Uploading...</span>
              }
              @if (displayFileIsTooLarge) {
                <div class="alert alert-error beta-version" role="error">
                  <p>
                    <i class="fas fa-fw fa-exclamation-circle fa-lg"></i> File is too large.
                  </p>
                </div>
              }
              @if (isUploading) {
                <div>
                  @if (uploader.value.queue.length > 0) {
                    <div>
                      <div>
                        <div class="progress mb-3 mt-1">
                          <div class="progress-bar" role="progressbar" attr.aria-valuenow="{{uploader.value.progress}}" attr.aria-valuemin="0" attr.aria-valuemax="100" [ngStyle]="{ 'width': uploader.value.progress + '%' }"></div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            } @else {
              <p>{{uploader.key.name}}
                <span role="button" (click)="deleteAttachment(uploader.key.uploadedFileId)" class="pl-3">
                  <i class="fal fa-trash-alt fa-fw fa-lg link" title="delete attachment"></i>
                </span></p>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>


  @if (displayFileUploadFailed) {
    <div class="row">
      <div class="alert alert-error" role="error" >
        <p>
          <i class="fas fa-fw fa-exclamation-circle fa-lg"></i> {{displayErrorMessage}} {{failedUploadedFileName}}.
        </p>
      </div>
    </div>
  }